module.exports = __webpack_public_path__ + "media/images/lb/917-8380e8ea3d64420df9779171578dba02.svg";